import { Box } from "@mui/material"
import { styled } from "@mui/system"
import React from "react"

interface BlurredBackgroundImageProps {
  imageSrc: string
  children: React.ReactNode
  className?: string
}

const BlurredBackgroundImage = (props: BlurredBackgroundImageProps) => {
  const { className, children, imageSrc } = props
  return (
    <_Container className={className} imageSrc={imageSrc}>
      {children}
    </_Container>
  )
}

export default BlurredBackgroundImage

const _Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "imageSrc",
})<{ imageSrc: string; className?: string }>(({ imageSrc }) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  zIndex: 1,
  overflow: "hidden",

  "&::before": {
    content: `""`,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: `url(${imageSrc})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    zIndex: -1,
  },

  "&::after": {
    content: `""`,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: "rgba(0, 0, 0, 0.75)",
    backdropFilter: "blur(10px)",
    zIndex: -1,
  },
}))
